import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import classRoomImg from "../../../../assets/img/teacherDashboard/Classroom.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import NotificationTable from "./NotificationTable";
import ReceivedNotificationTable from "./ReceivedNotificationTable";
import { useGetSchoolNotificationList } from "../../../../hooks/school/notification/useGetSchoolNotificationList";
import { useTenantAuth } from "../../../../context/TeanantAuthProvider";
import { ROLE_CONFIG } from "./RolesTab";
import "./Notification.css";

export const SchoolNotifications = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const { currentUser } = useTenantAuth();
  const role = currentUser?.role_slug;
  const isSubTenant = currentUser?.auth?.tenant_type === "sub";

  const [activeTab, setActiveTab] = useState(
    tabParam === "unread" && isSubTenant ? "received" : "sent",
  );
  const [currentPage, setCurrentPage] = useState(1);

  const { notifications, meta, loading, error, getSentNotifications } =
    useGetSchoolNotificationList();

  useEffect(() => {
    if (activeTab === "sent") {
      getSentNotifications({ page: currentPage });
    }
  }, [currentPage, activeTab]);

  const handleRefresh = () => {
    getSentNotifications({ page: currentPage });
  };

  return (
    <div className="classroom-cnt">
      <div className="classroom-container">
        <img src={classRoomImg} className="img" alt="Notification Centre" />
        <h2 className="text">Notification Centre</h2>
      </div>

      <div className="btn-container">
        <Button
          className="primary-btn"
          onClick={() => {
            const route = ROLE_CONFIG[role]?.notification?.create || "/";
            navigate(route);
          }}
        >
          Create New
        </Button>
      </div>

      {isSubTenant && (
        <div className="tabs-container">
          <button
            className={`tab-btn ${activeTab === "sent" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("sent");
              setCurrentPage(1);
            }}
          >
            Sent
          </button>
          <button
            className={`tab-btn ${activeTab === "received" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("received");
            }}
          >
            Received
          </button>
        </div>
      )}

      <div>
        {activeTab === "sent" ? (
          <NotificationTable
            notifications={notifications}
            loading={loading}
            error={error}
            metaData={meta}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handleRefresh={handleRefresh}
          />
        ) : (
          <ReceivedNotificationTable initialReadStatus={tabParam === "unread" ? "unread" : "all"} />
        )}
      </div>
    </div>
  );
};
